;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.controllers')
    .controller('SelectTemplateController', SelectTemplateController)

  SelectTemplateController.$inject = [
    // Angular
    '$uibModalInstance',

    // Managers
    'InvoiceTemplateManager',
    'QuoteTemplateManager',
    'CreditNoteTemplateManager',
    'DefaultQuoteTemplateManager',
    'DefaultInvoiceTemplateManager',
    'DefaultCreditNoteTemplateManager',

    // Resolve
    'type'

  ]

  function SelectTemplateController (
    // Angular
    $uibModalInstance,

    // Managers
    InvoiceTemplateManager,
    QuoteTemplateManager,
    CreditNoteTemplateManager,
    DefaultQuoteTemplateManager,
    DefaultInvoiceTemplateManager,
    DefaultCreditNoteTemplateManager,

    // Resolve
    type

  ) {
    var self = this

    init()

    function init () {
      self.templates = self.templates || {}
      switch (type) {
        case 'invoice':
          self.objLabel = 'de facture'
          self.loading = true
          DefaultInvoiceTemplateManager.get().then(function (defInvoices) {
            var defaultInvoiceTemplates = _.filter(defInvoices.data, function (elt) {
              return !elt.isSituation
            })
            var query = InvoiceTemplateManager.query({
              conditions: {
                isProforma: {
                  $ne: true
                }
              }
            })
            InvoiceTemplateManager.get(query).then(function (customInvoices) {
              self.templates = defaultInvoiceTemplates.concat(_.filter(customInvoices.data, function (elt) {
                return !elt.isSituation
              }))
              self.loading = false
            })
          })
          break
        case 'situation':
          self.objLabel = 'de facture de situation'
          self.loading = true
          DefaultInvoiceTemplateManager.get().then(function (defInvoices) {
            var defaultInvoiceTemplates = _.filter(defInvoices.data, function (elt) {
              return elt.isSituation === true
            })
            InvoiceTemplateManager.get().then(function (customInvoices) {
              self.templates = defaultInvoiceTemplates.concat(_.filter(customInvoices.data, function (elt) {
                return elt.isSituation === true
              }))
              self.loading = false
            })
          })
          break
        case 'quote':
          self.objLabel = 'de devis'
          self.loading = true
          DefaultQuoteTemplateManager.get().then(function (defQuotes) {
            var defaultQuoteTemplates = defQuotes.data
            QuoteTemplateManager.get().then(function (customQuotes) {
              self.templates = defaultQuoteTemplates.concat(customQuotes.data)
              self.loading = false
            })
          })
          break
        case 'creditnote':
          self.objLabel = "d'avoir"
          self.loading = true
          DefaultCreditNoteTemplateManager.get().then(function (defCreditNotes) {
            var defaultCreditNoteTemplates = defCreditNotes.data
            CreditNoteTemplateManager.get().then(function (customCreditNotes) {
              self.templates = defaultCreditNoteTemplates.concat(customCreditNotes.data)
              self.loading = false
            })
          })
          break
        case 'proforma':
          self.objLabel = 'PROFORMA'
          self.loading = true
          InvoiceTemplateManager.get(InvoiceTemplateManager.query({
            conditions: {
              isProforma: true,
              isSituation: {
                $ne: true
              }
            }
          })).then(function (templates) {
            self.templates = templates.data
            self.loading = false
          })
      }
    }

    function accept (template) {
      $uibModalInstance.close(template)
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }

    _.extend(self, {
      cancel: cancel,
      accept: accept
    })
  }
})(window.angular, window._)
